/**
 * Base Destination Interface
 * All destinations must implement this interface
 */

import { EventData } from '../hangarx'

export interface DestinationConfig {
  enabled: boolean
  [key: string]: any
}

export interface Destination {
  name: string
  enabled: boolean
  
  /**
   * Send events to the destination
   */
  send(events: EventData[]): Promise<void>
  
  /**
   * Identify a user
   */
  identify?(userId: string, traits?: Record<string, any>): Promise<void>
  
  /**
   * Track a page view
   */
  page?(name?: string, properties?: Record<string, any>): Promise<void>
}

export abstract class BaseDestination implements Destination {
  abstract name: string
  enabled: boolean
  
  constructor(
    protected config: DestinationConfig,
    protected debug: boolean = false
  ) {
    this.enabled = config.enabled ?? true
  }
  
  abstract send(events: EventData[]): Promise<void>
  
  protected log(message: string, data?: any): void {
    if (this.debug) {
      console.log(`[HangarX:${this.name}] ${message}`, data)
    }
  }
  
  protected logError(message: string, error: any): void {
    if (this.debug) {
      console.error(`[HangarX:${this.name}] ${message}`, error)
    }
  }
}
